import PlanCard from "./PlanCard";
import Select from "components/common/controls/Select";
import { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { ControlSize } from "shared/enums/ControlSizeEnum";
import AutoPurchasableProductLicenseDataForDrpodown from "interfaces/response/AutoPurchasableProductLicenseDataForDrpodown";
import SubscriptionPlanButton from "./SubscriptionPlanButton";

interface Props {
  autoPurchasableProductLicense: AutoPurchasableProductLicenseDataForDrpodown[];
}

export default function PredefinedSubscriptionPlanCard(props: Props) {
  const { autoPurchasableProductLicense } = props;
  const history = useHistory();

  useEffect(() => {
    setSelectedOption(autoPurchasableProductLicense?.length !== 0 ? autoPurchasableProductLicense?.[0].id : 1);
  }, [autoPurchasableProductLicense]);

  const [selectedOptionPrice, setSelectedOptionPrice] = useState("0");
  const [selectedOption, setSelectedOption] = useState(1);

  const handleOnClick = () => {
    history.push("/sign-up");
  };

  const ActionButton = () => {
    return (
      <div className="mt-3">
        <SubscriptionPlanButton text="PURCHASE" onClick={handleOnClick} />
      </div>
    );
  };

  const ActionInformation = () => {
    const handleChange = ({ selectedItem }: any) => {
      if (selectedItem) {
        setSelectedOptionPrice(selectedItem.price);
        setSelectedOption(selectedItem.id);
      }
    };

    return (
      <Select
        dataSource={autoPurchasableProductLicense}
        displayExpr="title"
        valueExpr="id"
        value={selectedOption}
        onSelectionChanged={handleChange}
        radiusSize={ControlSize.Midium}
      />
    );
  };

  return (
    <>
      <PlanCard
        name="Subscription"
        price={selectedOptionPrice}
        description="Dependable timePhasing API access at any scale."
        tag="per month, cancel anytime."
        actionInformation={<ActionInformation />}
        actionButton={<ActionButton />}
      />
    </>
  );
}
